module.exports = __webpack_public_path__ + "img/fricke.d191c93e.png";